import { useEffect, useState } from 'react';
import { INSTALL_STEPS, installMethod, onInstallChange, promptInstall, type InstallMethod } from '../lib/platform.ts';
import { Button, Card } from './ui.tsx';

/** A05 install explainer, platform-neutral: one-tap install where the browser supports it, steps otherwise. */
export function InstallCard({ compact = false }: { compact?: boolean }) {
  const [method, setMethod] = useState<InstallMethod>(() => installMethod());
  useEffect(() => onInstallChange(() => setMethod(installMethod())), []);
  if (method === 'installed') return null;
  return (
    <Card className={compact ? '' : 'mt-4'}>
      <h2 className="text-headline">Install Repwise</h2>
      <p className="text-sm text-text-muted mt-1">Opens like an app, works offline in the gym, and can alert you when your rest is up.</p>
      {method === 'prompt' ? (
        <div className="mt-3">
          <Button kind="secondary" onClick={() => void promptInstall().then(() => setMethod(installMethod()))}>
            Install Repwise
          </Button>
        </div>
      ) : (
        <p className="text-sm mt-2">{INSTALL_STEPS[method]}</p>
      )}
    </Card>
  );
}
